import PropTypes from 'prop-types'
import React from 'react'
import get from 'lodash/get'
import { useQuery } from '@apollo/client'
import { GET_CATEGORIES } from 'Queries'
import { Spinner, ErrorView, Link } from 'Blocks'
import { CATEGORY_DEFAULT_LIMIT } from 'Constants'
import Title from '../Title'
import { withGAEvent } from 'Utils'
import config, { gaSelectors } from 'Config'

const ParentCategories = props => {
  const { className } = props

  const variables = {
    arguments: {
      categoryUuid: process.env.ANT_BROWSE_ID
    },
    pagination: {
      size: CATEGORY_DEFAULT_LIMIT,
      page: 1
    }
  }

  const parentCategories = get(props, 'data.products.categories.top', [])

  const { loading, error, data } = useQuery(GET_CATEGORIES, { variables })

  if (!config.filters.parentCategories) return null
  if (loading) return <Spinner />
  if (error) return <ErrorView message={error.message} error={error} />
  return (
    <div {...{ className }}>
      {parentCategories.map((category, key) => {
        const hasDownArrow =
          !parentCategories.length && key === parentCategories.length - 1
        const { name, to } = category
        const GALink = withGAEvent(Link, {
          action: gaSelectors.getSubMenuSettings.action,
          category: gaSelectors.getSubMenuSettings.category.replace(
            '$1',
            props.gaEventContext
          ),
          label: `${name} - ${to}`,
          additionalProps: {
            linkName: name,
            destinationUrl: to,
          },
        })
        return (
          <GALink
            className="category-name"
            to={to}
            key={`parent-category-${to}`}
          >
            <Title {...{ hasDownArrow }} className="parent">
              {name}
            </Title>
          </GALink>
        )
      })}
    </div>
  )
}

ParentCategories.propTypes = {
  className: PropTypes.any,
  gaEventContext: PropTypes.any
}

export default ParentCategories
